<route>
{
  "meta": {
    "permission": [
      "whatsapp.view_inbox",
      "whatsapp.view_conversation"
    ]
  }
}
</route>
<template>
  <v-container fluid>
    <v-alert v-if="!account" type="info" text dense>
      {{ $t('whatsapp_not_configured') }}
    </v-alert>
    <!-- En pantalla chica los tres paneles no entran uno al lado del otro, y
         apilados dejan el hilo dos pantallas más abajo: se toca una
         conversación y parece que no pasó nada. Ahí se alterna entre la lista
         y el detalle, como cualquier aplicación de mensajería. -->
    <v-row v-else :class="{ 'inbox-row': !compact }">
      <v-col v-if="showList" cols="12" md="4" lg="3">
        <conversation-list ref="conversations" @select="select" />
      </v-col>
      <v-col v-if="showDetail" cols="12" md="5" lg="6">
        <message-thread @updated="refresh()" @back="back()" />
      </v-col>
      <v-col v-if="showDetail" cols="12" md="3">
        <context-panel @updated="refresh()" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import ConversationList from '@/components/whatsapp/ConversationList.vue'
import MessageThread from '@/components/whatsapp/MessageThread.vue'
import ContextPanel from '@/components/whatsapp/ContextPanel.vue'
export default {
  components: {
    ConversationList,
    MessageThread,
    ContextPanel
  },
  data() {
    return {
      account: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData',
      current: 'whatsapp/getCurrent'
    }),
    /**
     * Si la pantalla no da para los tres paneles a la vez.
     */
    compact() {
      return this.$vuetify.breakpoint.smAndDown
    },
    showList() {
      return !this.compact || !this.current
    },
    showDetail() {
      return !this.compact || Boolean(this.current)
    }
  },
  methods: {
    /**
     * Vuelve a la lista en pantalla chica.
     */
    back() {
      this.$store.dispatch('whatsapp/setCurrent', null)
    },
    /**
     * Abre una conversación y la marca como leída.
     */
    async select(conversation) {
      this.$store.dispatch('whatsapp/setCurrent', conversation)

      if (conversation.unread_count > 0) {
        try {
          const response = await this.$api.whatsapp.read({
            pk: conversation.pk,
            opt: { params: { company_id: this.company.pk } }
          })
          this.$store.dispatch('whatsapp/setCurrent', response.data)
          this.refresh()
        } catch (e) {
          // Marcar como leída es accesorio: no debe impedir abrir el hilo
        }
      }
    },
    /**
     * Abre la conversación que viene pedida en la dirección.
     *
     * Es el acceso directo desde ventas: la fila de una orden, la ficha del
     * cliente y el detalle de la suborden mandan el identificador y la bandeja
     * entra con el hilo abierto. Quien hace el enlace ya comprobó que la
     * conversación existe, así que acá un error sólo puede ser una
     * conversación borrada o de otra empresa: se deja la bandeja como siempre,
     * que igual es a donde se quería llegar.
     */
    async openFromRoute() {
      const pk = Number(this.$route.query.conversation)

      if (!pk) {
        return
      }

      try {
        const response = await this.$api.whatsapp.show({
          pk,
          opt: {
            params: { company_id: this.company.pk },
            skipErrorToast: true
          }
        })
        this.select(response.data)
      } catch (e) {
        // Si la imprenta perdió el complemento, el interceptor ya la lleva a
        // la pantalla que lo ofrece: un aviso rojo encima sería el segundo.
        const datos = e.response ? e.response.data : null

        if (!datos || datos.code !== 'whatsapp_addon_disabled') {
          this.$toast.error(this.$t('conversation_not_opened'))
        }
      }
    },
    refresh() {
      if (this.$refs.conversations) {
        this.$refs.conversations.load()
      }
    },
    async loadAccount() {
      const response = await this.$api.whatsapp.account.list({
        opt: { params: { company_id: this.company.pk } }
      })
      const results =
        response.data.results !== undefined
          ? response.data.results
          : response.data
      this.account = results.length > 0 ? results[0] : null
    }
  },
  mounted() {
    this.loadAccount()
    this.openFromRoute()
    this.$store.dispatch('whatsapp/connect', this.company.pk)
  },
  beforeDestroy() {
    this.$store.dispatch('whatsapp/disconnect')
  }
}
</script>
<style scoped>
/* En escritorio los tres paneles comparten el alto de la ventana y scrollean
   por dentro. Sin esto scrollea la página entera y, al bajar a leer mensajes
   viejos, el campo de escritura se va de la pantalla. Los 190px son el alto
   del encabezado, las migas y el pie, medidos sobre la pantalla real. */
.inbox-row {
  height: calc(100vh - 190px);
}
.inbox-row > [class*='col'] {
  height: 100%;
}
</style>
